
import firebase from '../../../firebase'
import { getUsersAndOther } from './utils'
import { watchForConversationUpdates } from './conversation-fire'

var db = firebase.firestore();

export const sendChatNotification = (conversationData, currentUser, next) => {

  return createChatNotification(currentUser, conversationData)

    .then((chatNotification) => {

      return chatNotificationRequest(chatNotification)

    })

}

export const createChatNotification = (currentUser, conversationData) => {

  var {userProfile: {email, username}, uid} = currentUser;

  console.log("CURRENT USER ", currentUser)

  var {users, other} = getUsersAndOther(uid, conversationData)

  console.log("conversationData USERS ", users)

  return db.collection("userProfiles")

    .where('userId', '==', other).get()

    .then(({docs: [userProfileDoc]}) => {

      var userProfile = {
        ...userProfileDoc.data(),
        id: userProfileDoc.id
      }

      return {
        username: username || email,
        email: userProfile.email,
        sender: uid,
        invitee: other,
        conversationUid: conversationData.id
      }

    })

}

export const chatNotificationRequest = ({conversationUid, email, username, sender, invitee}) => {
  var createConversationRequestUrl = `https://us-central1-fire-jitsu-chat.cloudfunctions.net/sendJitsuChatMessageNotification`

  return fetch(createConversationRequestUrl, {
    url: createConversationRequestUrl,
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      conversationUid,
      email,
      username,
      sender,
      invitee
    })
  })
    .then(response => response.json())
}



// WEBPACK FOOTER //
// ./src/Components/Conversations/middleware/chat-notifications.js